export default {
  props: {
    excerpt: {
      type: String,
    },
    readMoreText: {
      type: String,
      default: 'Read more',
    },
    readLessText: {
      type: String,
      default: 'Read less',
    },
    extraText: {
      type: String,
    },
    expanded: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      visible: this.expanded,
    };
  },

  computed: {
    isVisible() {
      return this.visible;
    },
    isHidden() {
      return !this.visible;
    },
  },

  methods: {
    calculateContentHeight() {
      const $content = this.$refs.content;

      return $content.offsetHeight;
    },

    setWrapperHeight() {
      const $wrapper = this.$refs.wrapper;

      if (this.visible) {
        $wrapper.style.height = `calc(${this.calculateContentHeight()}px + 1.6em)`;
      } else {
        $wrapper.style.height = 0;
      }
    },

    toggle() {
      this.visible = !this.visible;
      this.setWrapperHeight();
    },

    onResize() {
      if (this.visible) {
        this.calculateContentHeight();
        this.setWrapperHeight();
      }
    },
  },

  mounted() {
    this.setWrapperHeight();

    // update on resize
    window.addEventListener('resize', this.onResize);
  },

  destroyed() {
    window.removeEventListener('resize', this.onResize);
  },
};
